type ResultType = PromotionData | undefined;
type ApiResponseType = ApiSchema['Promotion'];
interface ParamsType { }

export default async function apiLoadPromotion(promotionCode: string): Promise<ApiResult<ResultType>> {
    try {
        return await callApiGet<PromotionData, ApiResponseType, ParamsType>(
            '/promotions',
            {
                promotionCode,
            },
            (response: ApiResponseType) => ({
                promotion: {
                    displayName: response.displayName,
                    name: response.name,
                    code: promotionCode,
                    promotionType: response.promotionType,
                },
                restrictions: {
                    validOrigins: (response.restriction?.validOrigins ?? []).map(transformPlace),
                    validDestinations: (response.restriction?.validDestinations ?? []).map(transformPlace),
                    requiresReductionCards: response.restriction?.requiresReductionCards,
                    validActivityIds: response.restriction?.validActivityIds ?? [],
                    validListingIds: response.restriction?.validListingIds ?? [],
                    validNamedRoutes: response.restriction?.validNamedRoutes ?? [],
                    enforceRoundtrip: response.restriction?.enforceRoundtrip ?? false,
                },
                validity: {
                    active: response.active,
                    redeemable: response.redeemable,
                },
            } satisfies PromotionData),
        );
    }
    catch (error: any) {
        if (error.status !== 404) {
            const fetchError = new Error('Failed to load promotion', { cause: error });
            handleError(fetchError, false, 'generic', {
                promotionCode,
            });
        }
        return {
            ok: false,
            warnings: [],
            data: undefined,
        };
    }
}
